// Logique du score de préservation, partagée entre le verdict et la carte de partage.

// Valeur de préservation d'un jeu (0 à 1) selon son état.
function gameValue(g) {
  const flagged = g.riskType && g.riskType !== 'safe';
  if (!flagged) return 1;
  if (g.savable || g.gogUrl) return 0.6;
  const s = g.severity || 1;
  return s >= 3 ? 0.05 : s === 2 ? 0.2 : 0.4;
}

// Score /100 calculé depuis la bibliothèque complète (fallback sur les compteurs).
export function computeScore(verdict) {
  const total = verdict?.totalGames || 0;
  if (!total) return 100;

  const lib = verdict.library && verdict.library.length ? verdict.library : null;
  let preserved;
  if (lib) {
    preserved = lib.reduce((acc, g) => acc + gameValue(g), 0);
  } else {
    const flagged = verdict.flaggedCount || 0;
    const safe = verdict.safeCount != null ? verdict.safeCount : Math.max(0, total - flagged);
    const savable = Math.min(verdict.savableCount || 0, flagged);
    preserved = safe + savable * 0.6 + Math.max(0, flagged - savable) * 0.2;
  }
  return Math.max(0, Math.min(100, Math.round((preserved / total) * 100)));
}

export function grade(score) {
  if (score >= 85) return { letter: 'A', tone: 'a' };
  if (score >= 70) return { letter: 'B', tone: 'b' };
  if (score >= 50) return { letter: 'C', tone: 'c' };
  if (score >= 30) return { letter: 'D', tone: 'd' };
  return { letter: 'F', tone: 'f' };
}
